// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cobranzaOther_has_tr__dVSNF {
  border-bottom: 1px solid #000;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Cobranza/cobranzaOther.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B","sourcesContent":[".has_tr {\n  border-bottom: 1px solid #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"has_tr": `cobranzaOther_has_tr__dVSNF`
};
export default ___CSS_LOADER_EXPORT___;
